import React from 'react';

import { ConfigProvider } from 'antd';

import { useClient } from '../../contexts';
import { FullPageSpinner } from '../../ui';
import { antdOverrides } from 'src/antd-overrides';
import { Rgpd } from '../../common/Rgpd/Rgpd';

import styles from './App.module.css';
import { PermissionsProvider } from '../../contexts/Permissions/PermissionsCheck';

// To avoid winding up with a large bundle,
// we use react-lazy api to code splitting our application
// and create multiple bundles that can be dynamically loaded at runtime.
// https://reactjs.org/docs/code-splitting.html
const AppAuthenticated = React.lazy(
  () => import(/* webpackPrefetch: true */ './App-authenticated')
);
const AppUnauthenticated = React.lazy(() => import('./App-unauthenticated'));

const App: React.FC = () => {
  const { status } = useClient();

  if (status === 'loading') {
    return (
      <div className={styles.spinner}>
        <FullPageSpinner />
      </div>
    );
  }
  return (
    <ConfigProvider theme={antdOverrides}>
      <div className={styles.root}>
        <React.Suspense
          fallback={
            <div className={styles.spinner}>
              <FullPageSpinner />
            </div>
          }
        >
          {status === 'authenticated' ? (
            <PermissionsProvider>
              <AppAuthenticated />
            </PermissionsProvider>
          ) : (
            <AppUnauthenticated />
          )}
        </React.Suspense>
        <Rgpd />
      </div>
    </ConfigProvider>
  );
};

export default App;
